import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Snackbar,
  TextField,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import Notification from "../common/Notification";
import UserMenu from "../common/UserMenu";
import countryList from "../../constants/countryList.json";
import { feedbackService } from "../../services/feedback.service";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Paper from "@material-ui/core/Paper";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { dashboardservice } from "../../services/dashboard.service";
import AuthContext from "../../store/auth-context";
import { Alert } from "@material-ui/lab";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FeedbackSubmission from "./FeedbackSubmission";
import FeedbackQuestionnaire from "./FeedbackQuestionnaire";
import { Link, useHistory, useLocation } from "react-router-dom";
import Complaints from "./Complaints";
import { useTranslation } from "react-i18next";
import { decode } from "html-entities";
import { pushToDataLayer } from "../../utils/gtm";

function Feedback() {
  const authCtx = useContext(AuthContext);
  const { t } = useTranslation();
  const [complaint, setComplaint] = useState<any>(false);
  const [facility, setFacility] = useState<any>(false);
  const [feedComp, setFeedComp] = useState<any>(false);

  const [selectionValue, setSelectionValue] = useState<any>({});
  const [facilityDropdownWide, setFacilityDropdownWide] =
    useState<boolean>(true);
  const [showGoButton, setShowGoButton] = useState<boolean>(true);
  const [showSelcectionDropdown, setShowSelectionDropdown] =
    useState<boolean>(true);
  const [renderFBScreen, setRenderFBScreen] = useState<Number>(0);
  const [fbSubmissionStatus, setFBSubmissionStatus] = useState<boolean>(false);
  const [feedbackLocations, setFeedbackLocations] = useState<any>([]);
  const [facilitySelected, setFacilitySelected] =
    useState<any>("Select Facility");
  const [facilityVblogValue, setFacilityVblogValue] = useState<any>(0);
  const [showApiErrorMsg, setShowApiErrorMsg] = useState<boolean>(false);
  const [apiErrorText, setApiErrorText] = useState<string>("");
  const [feedbackPatientTypeList, setFeedbackPatientTypeList] = useState<any>(
    []
  );
  const [feedbackPatientType, setFeedbackPatientType] = useState<string>("");
  const [noPatientTypesFound, setNoPatientTypesFound] =
    useState<boolean>(false);

  // Handle case sensitivity safely
  const rawBrandName = localStorage.getItem("brandName");
  const safeBrandName = rawBrandName ? rawBrandName.toLowerCase() : "";

  const dropdownvalues = ["Select", "Feedback", "Complaint"];
  const history = useHistory();
  const defaultFacility = "Select Facility";

  useEffect(() => {
    const getLocationsData = () => {
      getAllFeedbackLocations();
    };
    getLocationsData();
  }, []);

  const getAllFeedbackLocations = async () => {
    authCtx.toggleLoader(true);
    let res = await feedbackService.getFeedbackLocations(1);
    if (res.data && res.data.status === "success") {
      // FIX: Filter out location with ID "BU10" (Burjeel Hospital Abu Dhabi)
      const filteredData = res.data.data.filter(
        (item: any) => item.locationId !== "BU10"
      );
      setFeedbackLocations(filteredData);
    } else {
      setApiErrorText(t("Error"));
      setShowApiErrorMsg(true);
    }
    authCtx.toggleLoader(false);
  };

  const getFeedbackPatientType = async (vblog: any) => {
    authCtx.toggleLoader(true);
    if (
      safeBrandName === "medeor" ||
      safeBrandName === "burjeel" ||
      safeBrandName === "lifecare" ||
      safeBrandName === "llh"
    ) {
      let res = await feedbackService.getFeedbackpatientType(vblog);
      if (res && res.data.status === "success") {
        setFeedbackPatientTypeList(res.data.data);
        setNoPatientTypesFound(false);
      } else {
        setFeedbackPatientTypeList([]);
        setNoPatientTypesFound(true);
        setApiErrorText(t("Sorry! No patient type for the selected facility"));
        setShowApiErrorMsg(true);
      }
    }
    authCtx.toggleLoader(false);
  };

  const handleSelectionChange = (e: any) => {
    setFeedComp(true);
    setSelectionValue(e.target.value);
    setFeedbackPatientType("");
    if (
      e.target.value.toLowerCase() === "feedback" &&
      facilitySelected !== "Select Facility"
    ) {
      getFeedbackPatientType(facilityVblogValue);
      setRenderFBScreen(1);
      setShowSelectionDropdown(false);
      setFacilityDropdownWide(false);
    } else if (
      e.target.value.toLowerCase() === "complaint" &&
      facilitySelected !== "Select Facility"
    ) {
      setComplaint(true);
      setShowSelectionDropdown(false);
      setFacilityDropdownWide(false);
    }
  };

  const handleFSBackButtonClick = () => {
    setRenderFBScreen(0);
    setFacility(false);
    setComplaint(false);
    setShowSelectionDropdown(true);
    setFacilityDropdownWide(true);
    setFacilitySelected("Select Facility");
  };

  const getFeedbackSubmissionStatus = (value: any) => {
    setFBSubmissionStatus(value);
    if (value) {
       pushToDataLayer({
        event: 'pp_form_submit',
        form_name: 'Patient Feedback',
        doctor_name: '', 
        hospital_name: facilitySelected?.name || '',
        brand_name: localStorage.getItem("brandName") || 'Burjeel',
        specialty_name: feedbackPatientType || '' 
      });
      setRenderFBScreen(2);
    }
  };

  const getBackToFeedbackScreen = (isClick: any) => {
    if (isClick) {
      setRenderFBScreen(0);
      setFacilityDropdownWide(true);
      setShowSelectionDropdown(true);
      setFacility(false);
      setFeedComp(false);
      setComplaint(false);
    }
  };

  const handleFacilityChange = (e: any) => {
    e.stopPropagation();
    setFacility(true);
    if (e.target.value !== "Select Facility") {
      setFacilitySelected(JSON.parse(e.target.value));
      setFacilityVblogValue(JSON.parse(e.target.value).vblog);
      setFeedbackPatientTypeList("");
      setFeedbackPatientType("");
    } else {
      setFacility(false);
      setFacilityVblogValue(0);
    }
  };

  const handlePatientTypeChange = (e: any) => {
    setFeedbackPatientType(e.target.value);
  };

  // Function expects 'vblogValue' as a direct argument
  const renderFeedbackScreens = (vblogValue: any) => {
    if (renderFBScreen === 1) {
      return (
        <FeedbackQuestionnaire
          facilityVblogValue={vblogValue}
          handleBackButton={handleFSBackButtonClick}
          fbSubmissionStatus={getFeedbackSubmissionStatus}
          feedbackPatientType={feedbackPatientType}
          feedbackPatientTypeList={feedbackPatientTypeList}
          noPatientTypesFound={noPatientTypesFound}
        />
      );
    } else if (renderFBScreen === 2) {
      return (
        <FeedbackSubmission
          facilityName={facilitySelected}
          getBackToFBHome={getBackToFeedbackScreen}
        />
      );
    }
  };

  const handleClose = () => {
    setShowApiErrorMsg(false);
  };

  const renderSubmissionScreen = () => {
    return (
      <div>
        <h6 className="col-md-7 col-xs-12 mx-auto text-center">
          {t("We Would")}
          <FavoriteIcon sx={{ color: "red" }} />
          {t("Your Feedback")}
        </h6>
        <div className="col-md-7 mx-auto">
          <div
            className={
              "bg-white " +
              (!facilityDropdownWide
                ? "col-md-12 col-xs-12 mx-auto"
                : "col-md-7 col-xs-12 float-start mx-auto")
            }
          >
            {feedbackLocations && (
              <select
                className="ms-auto me-4 form-select fs-14 no-focus rounded-0.5rem"
                id="selectlocation"
                disabled={renderFBScreen !== 0 ? true : false}
                value={JSON.stringify(facilitySelected)}
                onChange={(e) => handleFacilityChange(e)}
              >
                <option value="Select Facility">{t("Select Facility")}</option>
                {feedbackLocations &&
                  feedbackLocations.map((item: any, index: any) => (
                    <option key={index} value={JSON.stringify(item)}>
                      {decode(item.name)}
                    </option>
                  ))}
              </select>
            )}
          </div>
          {renderFBScreen === 1 &&
            (safeBrandName === "medeor" ||
              safeBrandName === "burjeel" ||
              safeBrandName === "lifecare" ||
              safeBrandName === "llh") && (
              <div
                className={
                  "bg-white" +
                  (!facilityDropdownWide
                    ? "col-md-12 col-xs-12 mx-auto mt-2"
                    : "col-md-7 col-xs-12 float-start mx-auto mt-2")
                }
              >
                <select
                  className="ms-auto me-4 form-select fs-14 no-focus rounded-0.5rem"
                  id="selectPatientType"
                  value={feedbackPatientType}
                  onChange={(e) => handlePatientTypeChange(e)}
                >
                  <option value="">{t("Select Visit Type")}</option>
                  {feedbackPatientTypeList &&
                    feedbackPatientTypeList.map((item: any, index: any) => (
                      <option key={index} value={item.patient_type_value}>
                        {item.patient_type_label}
                      </option>
                    ))}
                </select>
              </div>
            )}
          <div className="col-md-3 col-xs-12 float-start ms-2">
            {showSelcectionDropdown && (
              <select
                className="form-select fs-14 no-focus"
                id="selectFeedbackType"
                defaultValue="Select"
                disabled={facility ? false : true}
                onChange={(e) => handleSelectionChange(e)}
              >
                {dropdownvalues &&
                  dropdownvalues.map((ele: any, index: any) => (
                    <option key={index} value={ele}>
                      {t(ele)}
                    </option>
                  ))}
              </select>
            )}
          </div>
        </div>
      </div>
    );
  };

  const openMobileMenu = (e: any) => {
    e.preventDefault();
    document.getElementById("leftMenu")?.classList.remove("d-none");
  };

  return (
    <>
      <div className="main-content animate py-4 px-3 px-sm-4">
        {!complaint ? (
          <div>
            <div className="d-flex align-items-center mb-3">
              <a
                href="#"
                className="d-inline-block d-sm-none text-dark"
                onClick={(e) => openMobileMenu(e)}
              >
                <i className="material-icons-outlined me-2">menu</i>
              </a>
              <h3 className="fs-18-24">{t("Feedback & Complaint")}</h3>
              <div
                className={`${authCtx.selectedLanguage === "en" ? "ms-auto" : "mr-auto"
                  } mw-90px`}
              >
                <Notification />
                <UserMenu />
              </div>
            </div>
            {renderFBScreen !== 2 ? renderSubmissionScreen() : null}

            <div className="col-md-7 mx-auto">
              {renderFBScreen !== 0
                // FIX: Passed 'facilityVblogValue' directly, NOT inside an object {}
                ? renderFeedbackScreens(facilityVblogValue)
                : null}
            </div>
            <div className="col-md-1 mx-auto mt-5 pt-4 px-3"></div>
          </div>
        ) : (

          <Complaints
            facilityName={facilitySelected}
            getBackToFBHomeFromComp={getBackToFeedbackScreen}
            handleBackButton={handleFSBackButtonClick}
          />
        )}
      </div>

      <Snackbar
        open={showApiErrorMsg}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          {apiErrorText}
        </Alert>
      </Snackbar>
    </>
  );
}

export default Feedback;